import { schemas } from "@card-data/generated/api.client";
import type { z } from "zod";

export const ISSUERS = schemas.IssuersEnum.enum;
export type Issuer = z.infer<typeof schemas.IssuersEnum>;

export const NETWORKS = schemas.NetworksEnum.enum;
export type Network = z.infer<typeof schemas.NetworksEnum>;

export const CURRENCIES = schemas.CurrenciesEnum.enum;
export type Currency = z.infer<typeof schemas.CurrenciesEnum>;

export type Credit = z.output<typeof schemas.Credit>;
export type OfferAmount = z.output<typeof schemas.OfferAmount>;
export type Offer = z.output<typeof schemas.Offer>;
export type CreditCard = z.output<typeof schemas.CreditCard>;
